import { InjectionToken } from '@angular/core';

/**
 * Use this to add a new preload link tag to the header
 */
export const createPreload = (document: Document, href: string, as: string) => {
    const head = document.getElementsByTagName('head')[0];
    const link: Element = document.createElement('link');
    /**
     * @SSR: It's best to use the setAttribute when updating DOM elements.
     * SSR didn't know what to do with the 'as' property. Using the method
     * worked
     */
    link.setAttribute('rel', 'preload');
    link.setAttribute('as', as);
    link.setAttribute('href', href);
    head.appendChild(link);
};

export type CreatePreloadProvider = (document: any, href: string, as: string) => void;
export const CREATE_PRELOAD =
    new InjectionToken('CREATE_PRELOAD', {
        factory: () => createPreload
    });
